import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/core';
import jsonp from 'jsonp-promise';
import queryString from 'query-string';
import React, { useState } from 'react';
import Notification from '../assets/notification.svg';
import { EMAIL_REGEX } from '../utils/Utils';

const MailchimpForm = ({
  twitterName,
  mailchimpFormOpen,
  onNext,
  staticPubkey,
}) => {
  const url = 'https://finance.us2.list-manage.com/subscribe/post-json';

  const [email, setEmail] = useState('');
  const [isError, setIsError] = useState(false);
  // const [checkBox, setCheckBox] = useState([] as string[]);

  const handleSubmit = async () => {
    if (!email || !EMAIL_REGEX.test(email)) {
      setIsError(true);
      return;
    }
    console.log('staticPubkey', staticPubkey);
    const data = {
      id: '7b37bd7975',
      subscribe: 'Subscribe',
      u: '76a8d40a2a01af1b6fa3dc956',
      EMAIL: email,
      PUBKEY: staticPubkey,
    };

    // if (checkBox.includes('1')) {
    data['group[83710][1]'] = 1;
    // }
    // if (checkBox.includes('2')) {
    //   data['group[83710][2]'] = 2
    // }

    const { result, msg } = await jsonp(
      `${url}?${queryString.stringify(data)}`,
      { param: 'c' }
    ).promise;
    console.log('result', result);

    window.localStorage.setItem('mailchimpSet', 'true');
    onNext();

    if (result !== 'success') {
      throw Error(`Failed to subscribe: ${msg}`);
    }
  };

  return (
    <Modal isOpen={mailchimpFormOpen} onClose={() => null} isCentered size="xl">
      <ModalOverlay>
        <ModalContent>
          <ModalHeader textAlign="center">
            Stay informed about the status of the bet
          </ModalHeader>
          <ModalBody mx={0} textAlign="center">
            <Flex p={4} mx={8} alignItems="center" flex={0.5}>
              <Box w="full">
                <Image src={Notification} mx="auto" height="125px" my={1} />
                <Text fontSize="md" mt={4}>
                  <strong>
                    {twitterName === '' ? `We'll let you know once someone accepts the bet` : `We'll let you know once ${twitterName} confirms the bet`}
                  </strong>
                </Text>

                <Alert bg="#BF6358" p={1} mb={4}>
                  <AlertIcon color="white" w={20} mr={0} />
                  <AlertDescription color="white" fontSize="xs">
                    <b>IMPORTANT:</b> Once someone accepts the bet from
                    their end, you will then have 36 hours to finalize the bet
                    on your dashboard.
                  </AlertDescription>
                </Alert>

                <Input
                  pr="4.5rem"
                  mt={2}
                  type={'text'}
                  placeholder="Enter Email"
                  value={email}
                  w="300px"
                  isInvalid={isError}
                  name="EMAIL"
                  onChange={(e) => setEmail(e.target.value)}
                />

                {/* <CheckboxGroup onChange={(e: string[]) => setCheckBox(e)}>
                  <Checkbox
                    value="1"
                    name="group[83710][1]"
                    style={{ borderColor: '#333' }}
                  >
                    Use email to keep me informed about the status of my bet
                  </Checkbox>
                  <Checkbox
                    value="2"
                    name="group[83710][2]"
                  >
                    Allow Atomic Odds to reach out to me for product feedback
                  </Checkbox>
                </CheckboxGroup> */}
              </Box>
            </Flex>
            <Flex mt="2rem">
              <Button
                ml="auto"
                // h="100%"
                whiteSpace="normal"
                onClick={handleSubmit}
                colorScheme="blue"
              >
                Continue
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default MailchimpForm;
